import { component as defineComponent } from 'flightjs';

var slideShow = function () {
    this.attributes({
        resetEvent: null,
        showStepEvent: false,

        initialStatus: false,

        // Selectors
        stepSelector: '[data-slideshow-step]',
        prevBtnSelector: '[data-slideshow-prev-btn]',
        nextBtnSelector: '[data-slideshow-next-btn]',
        doneBtnSelector: '[data-slideshow-done-btn]',
        stepIndicatorSelector: '[data-slideshow-step-indicator-item]',
    });

    this.after('initialize', function () {
        // Store intial state for restoring
        this.storeInitialState();

        // Events
        this.on('click', {
            prevBtnSelector: this.showPreviousStep,
            nextBtnSelector: this.showNextStep,
        });
        this.on(document, this.attr.resetEvent, this.restoreInitialState);
        this.on(document, this.attr.showStepEvent, this.showStep);
    });

    this.restoreInitialState = function () {
        var $initialStep = this.select('stepSelector').filter(
            '[data-slideshow-step=' + this.attr.initialStatus + ']'
        );

        this.select('stepSelector').removeAttr('data-slideshow-step-active');
        $initialStep.attr('data-slideshow-step-active', true);
        this.updateIndicator();
        this.updateButtonStatus();
    };

    this.storeInitialState = function () {
        var $currentStep = this.select('stepSelector').filter('[data-slideshow-step-active]');

        this.attr.initialStatus = $currentStep.attr('data-slideshow-step');
    };

    this.showStep = function (e, data) {
        var $allSteps = this.select('stepSelector');
        var $requestedStep;

        data = data || {};

        if (data.step !== 'undefined' && data.step < $allSteps.length) {
            $requestedStep = $allSteps.eq(data.step);

            $allSteps.removeAttr('data-slideshow-step-active');
            $requestedStep.attr('data-slideshow-step-active', true);
            this.updateIndicator();
            this.updateButtonStatus();
        }
    };

    this.showPreviousStep = function () {
        var $allSteps = this.select('stepSelector');
        var $currentStep = this.select('stepSelector').filter('[data-slideshow-step-active]');
        var nextStep = $allSteps.get($currentStep.index() - 1);

        // Prevent reverse cycling through slideshow
        if ($currentStep.index() !== 0) {
            $currentStep.removeAttr('data-slideshow-step-active');
            $(nextStep).attr('data-slideshow-step-active', true);
            this.updateIndicator();
            this.updateButtonStatus();
        }
    };

    this.showNextStep = function () {
        var $allSteps = this.select('stepSelector');
        var $currentStep = this.select('stepSelector').filter('[data-slideshow-step-active]');
        var nextStep = $allSteps.get($currentStep.index() + 1) || $allSteps.get(0);

        $currentStep.removeAttr('data-slideshow-step-active');
        $(nextStep).attr('data-slideshow-step-active', true);
        this.updateIndicator();
        this.updateButtonStatus();
    };

    this.updateIndicator = function () {
        var $indicators = this.select('stepIndicatorSelector');
        var stepIndex = this.select('stepSelector').filter('[data-slideshow-step-active]').index();
        var nextIndicator = $indicators.get(stepIndex);

        $indicators.removeAttr('data-slideshow-step-indicator-item-active');
        $(nextIndicator).attr('data-slideshow-step-indicator-item-active', true);
    };

    this.updateButtonStatus = function () {
        var stepIndex = this.select('stepSelector').filter('[data-slideshow-step-active]').index();

        // Enable/disable previous button
        if (stepIndex === 0) {
            this.select('prevBtnSelector').attr('disabled', true);
        } else {
            this.select('prevBtnSelector').removeAttr('disabled');
        }

        // Enable/disable previous button
        if (stepIndex === this.select('stepSelector').length - 1) {
            this.select('nextBtnSelector').attr('data-slideshow-next-btn-hidden', true);
            this.select('doneBtnSelector').attr('data-slideshow-done-btn-active', true);
        } else {
            this.select('nextBtnSelector').removeAttr('data-slideshow-next-btn-hidden');
            this.select('doneBtnSelector').removeAttr('data-slideshow-done-btn-active');
        }
    };
};

export default defineComponent(slideShow);



// WEBPACK FOOTER //
// ./src/web/js/contest/ui/slideshow.js